// extracted by mini-css-extract-plugin
export default {"dayIcon":"day-icon_dayIcon__zcWSm","info":"day-icon_info__Stnep","warning":"day-icon_warning__bXOEF"};